<template>
  <div class="bill-payment page-content">
    <div class="bill-tab">
      <AttendancePagesHeading
        pageName="Bill"
        :date="date"
        :filterOptions="[
          { name: 'Name', value: 'name' },
          { name: 'Phone', value: 'phone' },
          { name: 'Bill Type', value: 'type' },
          { name: 'Account No', value: 'account_no' },
          { name: 'Bill Status', value: 'bill_status' }
        ]"
        @filterSearch="filterSearch"
        @sync="getBillList"
        @changeDate="changeDate"
      ></AttendancePagesHeading>
    </div>

    <div class="card">
      <div class="card-body">
        <DefaultLoader v-if="isLoading"></DefaultLoader>
        <template v-else-if="filteredBillList.length > 0">
          <div class="bill-table">
            <div class="col-md-12">
              <div class="row">
                <div class="table-responsive">
                  <CustomDataTable
                    :filteredData="filteredBillList"
                    :perPage="50"
                    @fetchPaginatedData="fetchPaginatedData"
                  >
                    <template #top-right>
                      <span
                        >Current Holidays: <b>{{ currentHolidays }}</b></span
                      >
                    </template>
                    <table class="table mt-3">
                      <thead style="height: 45px">
                        <tr>
                          <th>Owner Name</th>
                          <th>Owner Phone</th>
                          <th>Owner Bank</th>
                          <th>Owner AC No.</th>
                          <th>Driver Names</th>
                          <th>Verified By</th>
                          <th>Due Amount</th>
                          <th>Bill Summary</th>
                          <th v-if="filterValue.type">Bill Type</th>
                          <th>Bill Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody class="align-middle">
                        <template
                          v-for="bill in paginatedFilteredBillList"
                          :key="bill.user_code"
                        >
                          <tr>
                            <td>
                              {{
                                driverDetails.find(
                                  (driver) =>
                                    driver.user_code === bill.user_code
                                )
                                  ? driverDetails.find(
                                      (driver) =>
                                        driver.user_code === bill.user_code
                                    ).name
                                  : 'No Name Found'
                              }}
                            </td>
                            <td>
                              {{
                                driverDetails.find(
                                  (driver) =>
                                    driver.user_code === bill.user_code
                                )
                                  ? driverDetails.find(
                                      (driver) =>
                                        driver.user_code === bill.user_code
                                    ).mobile
                                  : 'No Name Found'
                              }}
                            </td>
                            <td>
                              <span v-if="bill.payment_method === 'bank'">{{
                                bill.bank_name ? bill.bank_name : 'N/A'
                              }}</span>
                              <span v-else>{{
                                bill.payment_method
                                  ? bill.payment_method
                                  : 'N/A'
                              }}</span>
                            </td>
                            <td>
                              {{ bill.account_no ? bill.account_no : 'N/A' }}
                              <!-- {{ bill.bkash_number }} -->
                              <!-- <i
                                class="bi bi-pen"
                                data-bs-toggle="modal"
                                @click="
                                  getListWiseBkashNumber(bill.user_code)
                                "
                                data-bs-target="#bkashNumberEditModal"
                              ></i> -->
                            </td>
                            <td>{{ billDriverNames(bill) }}</td>
                            <td>Operations team</td>
                            <td>
                              ৳
                              {{ parseFloat(floatingPointPlaces(bill.due, 2)) }}
                            </td>
                            <td>
                              <i
                                class="bi bi-eye"
                                data-bs-toggle="modal"
                                v-if="
                                  permissions.includes('bill-summary-modal')
                                "
                                @click="
                                  selectSummaryTab();
                                  getBillListAccordingDateUserCode(bill);
                                "
                                data-bs-target="#billSummaryModal"
                              ></i>
                            </td>
                            <td v-if="filterValue.type">
                              <span
                                class="partner-badge partner-badge-pink rounded-pill"
                                >{{ filterValue.type }}</span
                              >
                            </td>
                            <td
                              v-if="
                                bill.pending > bill.approved &&
                                bill.approved === 0
                              "
                              style="color: #ff9f5a"
                            >
                              Pending
                            </td>
                            <td
                              v-else-if="
                                filterValue.type === 'gasbill' &&
                                bill.requested > 0
                              "
                              style="color: #a95eea"
                            >
                              Requested
                            </td>
                            <td
                              v-else-if="
                                bill.approved === bill.requested &&
                                bill.pending === bill.approved
                              "
                              style="color: #a95eea"
                            >
                              Requested
                            </td>
                            <td
                              v-else-if="bill.pending > bill.approved"
                              style="color: #0a30ef"
                            >
                              Partially Approved
                            </td>
                            <td
                              v-else-if="bill.pending === bill.approved"
                              style="color: #00ab30"
                            >
                              Approved
                            </td>
                            <td>
                              <button
                                class="btn btn-sm btn-primary"
                                v-if="
                                  bill.pending > bill.approved &&
                                  bill.approved === 0
                                "
                                @click="reverseBill(bill.bills_id)"
                              >
                                <i class="bi bi-arrow-clockwise"></i>
                              </button>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </CustomDataTable>
                </div>
              </div>
            </div>
          </div>
        </template>
        <NoDataMessage v-else></NoDataMessage>
      </div>
    </div>

    <teleport to="body">
      <div
        class="modal fade"
        id="bkashNumberEditModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <form @submit.prevent="updateBkashNumber">
            <div class="modal-content">
              <div class="modal-header">
                <h4
                  class="modal-title"
                  id="exampleModalLabel"
                  style="font-family: Montserrat"
                >
                  bKash Number Edit
                </h4>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="col-md-12">
                  <div class="row">
                    <div class="mb-3">
                      <label for="bKashNo" class="form-label">bKash No.</label>
                      <input
                        type="text"
                        required
                        maxlength="11"
                        v-model="editBkashNumber"
                        class="form-control"
                        id="bKashNo"
                        placeholder="01821123202"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <div class="col-md-12">
                  <div class="row">
                    <button
                      type="submit"
                      class="btn btn-lg btn-primary d-grid gap-2 col-8 mx-auto"
                      data-bs-dismiss="modal"
                      @click="updateBkashNumber"
                      style="
                        background-color: #262c66;
                        color: #ffffff;
                        border: 1px solid #262c66;
                      "
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </teleport>
    <teleport to="body">
      <div
        class="modal fade"
        id="billSummaryModal"
        tabindex="-1"
        aria-labelledby="billSummaryModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h5
                class="modal-title"
                id="billSummaryModalLabel"
                style="font-size: 18px; font-weight: 600; line-height: 31px"
              >
                Bill Summary
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6 float-start">
                    <h3
                      class="fw-bold font-Montserrat"
                      style="
                        font-size: 20px;
                        font-weight: 600;
                        line-height: 32px;
                      "
                    >
                      {{ billUserName }}
                    </h3>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6 float-start mt-1">
                    <h4
                      style="
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 14px;
                      "
                    >
                      CD:
                      <template
                        v-for="(tripIdCode, index) in uniqueTripCodeRoutes"
                        :key="tripIdCode.trip_code"
                      >
                        <a
                          target="_blank"
                          :href="
                            '/trip-request/vehicle-request/details/' +
                            tripIdCode.trip_request_id
                          "
                          >{{ tripIdCode.trip_code }}</a
                        ><span
                          :class="
                            uniqueTripCodeRoutes.length - 1 == index
                              ? 'd-none'
                              : ''
                          "
                          >,
                        </span>
                      </template>
                    </h4>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <h4
                  style="font-size: 16px; font-weight: 500; line-height: 14px"
                >
                  Payment Method:
                  {{
                    selectedBill.payment_method
                      ? selectedBill.payment_method
                      : 'N/A'
                  }}
                  <button
                    class="btn btn-xs btn-primary"
                    @click="showPaymentMethodsModal = true"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </h4>

                <div class="row" v-if="selectedBill.payment_method">
                  <div
                    v-if="selectedBill.payment_method === 'bkash'"
                    class="col-md-6 float-start mt-1"
                  >
                    <h4
                      style="
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 14px;
                      "
                    >
                      bKash No: {{ selectedBill.account_no }}
                    </h4>
                  </div>
                  <div v-else class="col-md-6 float-start mt-1">
                    <h4
                      style="
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 14px;
                      "
                    >
                      Bank Name: {{ selectedBill.bank_name }}
                    </h4>
                    <h4
                      style="
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 14px;
                      "
                    >
                      Customer Name: {{ selectedBill.customer_name }}
                    </h4>
                    <h4
                      style="
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 14px;
                      "
                    >
                      Account No: {{ selectedBill.account_no }}
                    </h4>
                    <h4
                      style="
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 14px;
                      "
                    >
                      Routing No: {{ selectedBill.routing_no }}
                    </h4>
                  </div>
                </div>
              </div>

              <template v-if="filterValue.type !== 'gasbill'">
                <div class="row mt-5">
                  <div class="col-md-12">
                    <ul class="nav nav-tabs bill-nav">
                      <li class="nav-item">
                        <a
                          :class="{
                            'nav-link': true,
                            active: selectedDriverCode === 'summary'
                          }"
                          style="cursor: pointer"
                          @click="selectSummaryTab()"
                          >Summary</a
                        >
                      </li>
                      <template
                        v-for="(
                          routeUserWiseAmountSummary, key
                        ) in userRouteWiseTripIncome"
                        :key="key"
                      >
                        <li class="nav-item" v-if="!isBillSummaryLoading">
                          <a
                            :class="{
                              'nav-link': true,
                              active: selectedDriverCode === key
                            }"
                            style="cursor: pointer"
                            @click="selectUserRouteTab(key)"
                          >
                            {{
                              billDriverDetails.find(
                                (driver) => driver.user_code === key
                              )
                                ? billDriverDetails.find(
                                    (driver) => driver.user_code === key
                                  ).name
                                : 'No Name Found'
                            }}
                          </a>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-8">
                    <nav style="margin-top: 10px">
                      <div class="nav nav-pills" id="nav-tab" role="tablist">
                        <button
                          ref="summaryTab"
                          class="nav-link active"
                          style="display: none"
                          id="nav-home-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-summary"
                          type="button"
                          role="tab"
                          aria-controls="nav-summary"
                          aria-selected="true"
                        >
                          Summary
                        </button>
                        <template
                          v-if="
                            userRouteWiseTripIncome[selectedDriverCode] &&
                            ((userRouteWiseTripIncome[selectedDriverCode]
                              .routeWiseTripIncomeAndShuttleBonus &&
                              Array.isArray(
                                userRouteWiseTripIncome[selectedDriverCode]
                                  .routeWiseTripIncomeAndShuttleBonus
                              )) ||
                              (userRouteWiseTripIncome[selectedDriverCode]
                                .routeWiseTripIncome &&
                                Array.isArray(
                                  userRouteWiseTripIncome[selectedDriverCode]
                                    .routeWiseTripIncome
                                )))
                          "
                        >
                          <template
                            v-for="(data, index) in userRouteWiseTripIncome[
                              selectedDriverCode
                            ].routeWiseTripIncomeAndShuttleBonus
                              ? userRouteWiseTripIncome[selectedDriverCode]
                                  .routeWiseTripIncomeAndShuttleBonus
                              : userRouteWiseTripIncome[selectedDriverCode]
                                  .routeWiseTripIncome"
                            :key="index"
                          >
                            <button
                              ref="userRouteTab"
                              class="nav-link"
                              style="margin-right: 10px"
                              :id="
                                $format.onlyLetterString(data.route_name) +
                                '-tab-' +
                                $format.onlyAlphanumericString(
                                  selectedDriverCode
                                ) +
                                '-' +
                                index
                              "
                              data-bs-toggle="tab"
                              @click="
                                getDateRouteWiseAmountCalculationShow(
                                  data.route_id,
                                  selectedDriverCode,
                                  data.service_type,
                                  userRouteWiseTripIncome[selectedDriverCode]
                                    .bills_id
                                )
                              "
                              :data-bs-target="
                                '#' +
                                $format.onlyLetterString(data.route_name) +
                                '-' +
                                $format.onlyAlphanumericString(
                                  selectedDriverCode
                                ) +
                                '-' +
                                index
                              "
                              type="button"
                              role="tab"
                              aria-controls="nav-profile"
                              aria-selected="false"
                            >
                              {{ data.route_name?.replace(/\s()-/g, '') }}
                              <br />
                              <span v-if="data.company_code"
                                >({{ data.company_code }})</span
                              >
                              <span v-else-if="data.service_type"
                                >({{ data.service_type }})</span
                              >
                            </button>
                          </template>
                          <button
                            class="nav-link"
                            style="background: #e2e555"
                            v-if="adjustedAmount && adjustedAmount.length > 0"
                            data-bs-toggle="tab"
                            data-bs-target="#adjustedAmountsTab"
                          >
                            Adjusted Amounts
                          </button>
                        </template>
                      </div>
                    </nav>
                  </div>
                  <div class="col-md-4">
                    <button
                      type="button"
                      v-if="
                        selectedDriverCode !== 'summary' &&
                        tripBillStatus !== 'Approved'
                      "
                      class="btn btn-primary"
                      style="margin-top: 10px; float: right"
                      data-bs-toggle="modal"
                      data-bs-target="#billAdjustment"
                    >
                      Adjust Bill
                    </button>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="tab-content mt-3" id="nav-tabContent">
                      <div
                        class="tab-pane fade show active"
                        id="nav-summary"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab"
                      >
                        <div class="col-md-12">
                          <div class="row">
                            <template v-if="isBillSummaryLoading">
                              <div class="d-flex justify-content-center">
                                <div class="spinner-border" role="status">
                                  <span class="visually-hidden"
                                    >Loading...</span
                                  >
                                </div>
                              </div>
                            </template>
                            <template v-else>
                              <div class="table-responsive">
                                <BillSummaryFleetVariable
                                  v-if="
                                    filterValue.modality === 'fleet-variable'
                                  "
                                  :billDriverDetails="billDriverDetails"
                                  :userRouteWiseTripIncome="
                                    userRouteWiseTripIncome
                                  "
                                  @switchTab="switchTab"
                                ></BillSummaryFleetVariable>
                                <table v-else class="table table-bordered">
                                  <thead>
                                    <!-- <th>Types</th> -->
                                    <th>Name</th>
                                    <th>Routes</th>
                                    <th>CD</th>
                                    <th>Trip Count</th>
                                    <th>Per Trip Price</th>
                                    <th>Monthly Earning</th>
                                    <!-- <th>Shuttle Bonus</th> -->
                                    <template
                                      v-if="
                                        filterValue.modality === 'fleet-fixed'
                                      "
                                    >
                                      <th>Body Rent</th>
                                      <th>Lunch Allowance / Day</th>
                                      <th>Backup Cost</th>
                                    </template>
                                    <th v-else>Completion Bonus</th>
                                    <th>Adjustment</th>
                                    <th>Total</th>
                                    <!-- <th>Total</th> -->
                                  </thead>
                                  <tbody>
                                    <template
                                      v-for="(
                                        routeWiseTripIncome, key
                                      ) in userRouteWiseTripIncome"
                                      :key="key"
                                    >
                                      <template
                                        v-if="
                                          routeWiseTripIncome.routeWiseTripIncomeAndShuttleBonus &&
                                          Array.isArray(
                                            routeWiseTripIncome.routeWiseTripIncomeAndShuttleBonus
                                          )
                                        "
                                      >
                                        <template
                                          v-for="(
                                            data, index
                                          ) in routeWiseTripIncome.routeWiseTripIncomeAndShuttleBonus"
                                          :key="index"
                                        >
                                          <tr>
                                            <td
                                              v-if="index == 0"
                                              :rowspan="
                                                routeWiseTripIncome
                                                  .routeWiseTripIncomeAndShuttleBonus
                                                  .length
                                              "
                                            >
                                              {{
                                                billDriverDetails.find(
                                                  (driver) =>
                                                    driver.user_code === key
                                                )
                                                  ? billDriverDetails.find(
                                                      (driver) =>
                                                        driver.user_code === key
                                                    ).name
                                                  : 'No Name Found'
                                              }}
                                            </td>
                                            <td>
                                              <div
                                                class="text-primary"
                                                style="cursor: pointer"
                                                @click="
                                                  switchTab(
                                                    key,
                                                    $format.onlyLetterString(
                                                      data.route_name
                                                    ) +
                                                      '-tab-' +
                                                      $format.onlyAlphanumericString(
                                                        key
                                                      ) +
                                                      '-' +
                                                      index
                                                  )
                                                "
                                              >
                                                {{ data.route_name }}
                                                <span
                                                  v-if="
                                                    data.service_type === 'B2B'
                                                  "
                                                  >({{
                                                    data.company_code
                                                  }})</span
                                                >
                                                <span v-else
                                                  >({{
                                                    data.service_type
                                                  }})</span
                                                >
                                              </div>
                                            </td>
                                            <td>{{ data.trip_code }}</td>
                                            <td>
                                              {{ data.completedTripCount }}
                                            </td>
                                            <td>
                                              ৳
                                              {{
                                                floatingPointPlaces(
                                                  data.singleTripAmountWithShuttleBonus,
                                                  2
                                                )
                                              }}
                                            </td>
                                            <td>
                                              ৳
                                              {{
                                                floatingPointPlaces(
                                                  data.trip_income +
                                                    data.shuttle_bonus,
                                                  2
                                                )
                                              }}
                                            </td>
                                            <!-- <td>
                                            ৳
                                            {{
                                              floatingPointPlaces(
                                                data.shuttle_bonus,
                                                2
                                              )
                                            }}
                                          </td> -->
                                            <template
                                              v-if="
                                                filterValue.modality ===
                                                'fleet-fixed'
                                              "
                                            >
                                              <td>
                                                ৳
                                                {{
                                                  floatingPointPlaces(
                                                    data.routeWiseBodyrent,
                                                    2
                                                  )
                                                }}
                                              </td>
                                              <td>
                                                ৳
                                                {{
                                                  floatingPointPlaces(
                                                    data.routeWiseLunchAllowance,
                                                    2
                                                  )
                                                }}
                                              </td>
                                              <td>
                                                ৳
                                                {{
                                                  floatingPointPlaces(
                                                    data.backup_cost,
                                                    2
                                                  )
                                                }}
                                              </td>
                                            </template>
                                            <template v-else>
                                              <td
                                                v-if="index == 0"
                                                :rowspan="
                                                  routeWiseTripIncome
                                                    .routeWiseTripIncomeAndShuttleBonus
                                                    .length
                                                "
                                                style="vertical-align: middle"
                                              >
                                                ৳
                                                {{
                                                  floatingPointPlaces(
                                                    routeWiseTripIncome.completionBonus,
                                                    2
                                                  )
                                                }}
                                              </td>
                                            </template>
                                            <td
                                              v-if="index == 0"
                                              :rowspan="
                                                routeWiseTripIncome
                                                  .routeWiseTripIncomeAndShuttleBonus
                                                  .length
                                              "
                                              style="vertical-align: middle"
                                            >
                                              <span
                                                v-if="
                                                  routeWiseTripIncome.adjustment
                                                "
                                                >৳
                                                {{
                                                  floatingPointPlaces(
                                                    routeWiseTripIncome
                                                      .adjustment
                                                      .adjustment_credited -
                                                      routeWiseTripIncome
                                                        .adjustment
                                                        .adjustment_debited,
                                                    2
                                                  )
                                                }}
                                              </span>
                                              <span v-else>৳ 0</span>
                                            </td>
                                            <td
                                              v-if="index == 0"
                                              :rowspan="
                                                routeWiseTripIncome
                                                  .routeWiseTripIncomeAndShuttleBonus
                                                  .length
                                              "
                                              style="vertical-align: middle"
                                            >
                                              ৳
                                              {{
                                                floatingPointPlaces(
                                                  routeWiseTripIncome.totalIncome,
                                                  2
                                                )
                                              }}
                                            </td>
                                          </tr>
                                        </template>
                                      </template>
                                    </template>
                                    <tr>
                                      <td
                                        :colspan="
                                          filterValue.modality === 'fleet-fixed'
                                            ? 10
                                            : 8
                                        "
                                        style="text-align: right"
                                      >
                                        Total
                                      </td>
                                      <td>
                                        ৳
                                        {{
                                          floatingPointPlaces(
                                            grandTotalWeeklyIncome,
                                            2
                                          )
                                        }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </template>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 d-grid gap-2">
                            <button
                              type="button"
                              v-if="
                                !(
                                  tripBillStatus === 'Approved' ||
                                  tripBillStatus === 'Requested'
                                )
                              "
                              class="btn btn-light"
                              data-bs-dismiss="modal"
                            >
                              Cancel
                            </button>
                          </div>
                          <div class="col-md-6 d-grid gap-2">
                            <button
                              v-if="$userPermission.has('approve-bill')"
                              type="button"
                              class="btn btn-primary justify-content-end"
                              data-bs-dismiss="modal"
                              @click="updateBillSummaryAccordingUser"
                              :disabled="
                                !selectedBill.payment_method ||
                                tripBillStatus === 'Approved' ||
                                tripBillStatus === 'Requested'
                              "
                            >
                              {{
                                tripBillStatus === 'Approved' ||
                                tripBillStatus === 'Requested'
                                  ? 'Approved'
                                  : 'Approve'
                              }}
                            </button>
                          </div>
                        </div>
                      </div>
                      <BillRouteDataFleetVariable
                        v-if="filterValue.modality === 'fleet-variable'"
                        :userRouteWiseTripIncome="userRouteWiseTripIncome"
                        :routeWiseDailyTransaction="routeWiseDailyTransaction"
                      ></BillRouteDataFleetVariable>
                      <template v-else>
                        <template
                          v-for="(
                            routeWiseTripIncome, key
                          ) in userRouteWiseTripIncome"
                          :key="key"
                        >
                          <template
                            v-if="
                              routeWiseTripIncome.routeWiseTripIncomeAndShuttleBonus &&
                              Array.isArray(
                                routeWiseTripIncome.routeWiseTripIncomeAndShuttleBonus
                              )
                            "
                          >
                            <template
                              v-for="(
                                data, index
                              ) in routeWiseTripIncome.routeWiseTripIncomeAndShuttleBonus"
                              :key="index"
                            >
                              <div
                                class="tab-pane fade"
                                :id="
                                  $format.onlyLetterString(data.route_name) +
                                  '-' +
                                  $format.onlyAlphanumericString(key) +
                                  '-' +
                                  index
                                "
                                role="tabpanel"
                                :aria-labelledby="
                                  'nav-' +
                                  $format.onlyLetterString(data.route_name) +
                                  '-tab-' +
                                  $format.onlyAlphanumericString(key) +
                                  '-' +
                                  index
                                "
                              >
                                <template v-if="isDateRouteBillSummaryLoading">
                                  <div class="d-flex justify-content-center">
                                    <div class="spinner-border" role="status">
                                      <span class="visually-hidden"
                                        >Loading...</span
                                      >
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <div class="col-md-12">
                                    <div class="row">
                                      <div class="table-responsive">
                                        <table class="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th>Date</th>
                                              <th>Time</th>
                                              <th>Daily Earning</th>
                                              <th>Shuttle Bonus</th>
                                              <th>Total Earning</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <template
                                              v-for="data in refinedRouteDateWiseAmount"
                                              :key="data.attendance_id"
                                            >
                                              <tr>
                                                <td>
                                                  {{
                                                    formatDateUsingMoment(
                                                      data.trip_start_date_time
                                                    )
                                                  }}
                                                </td>
                                                <td>
                                                  {{ data.time }}
                                                </td>
                                                <td>
                                                  ৳
                                                  {{
                                                    floatingPointPlaces(
                                                      data.tripAmount,
                                                      2
                                                    )
                                                  }}
                                                </td>
                                                <td>
                                                  ৳
                                                  {{
                                                    floatingPointPlaces(
                                                      data.shuttleBonus,
                                                      2
                                                    )
                                                  }}
                                                </td>
                                                <td>
                                                  ৳
                                                  {{
                                                    floatingPointPlaces(
                                                      data.tripAmount +
                                                        data.shuttleBonus,
                                                      2
                                                    )
                                                  }}
                                                </td>
                                              </tr>
                                            </template>
                                            <tr>
                                              <td
                                                colspan="2"
                                                class="align-middle"
                                              >
                                                Total
                                              </td>
                                              <td>
                                                ৳
                                                {{
                                                  floatingPointPlaces(
                                                    routeWiseDailyEarningCalculation,
                                                    2
                                                  )
                                                }}
                                              </td>
                                              <td>
                                                ৳
                                                {{
                                                  floatingPointPlaces(
                                                    routeWiseShuttleBonusCalculation,
                                                    2
                                                  )
                                                }}
                                              </td>
                                              <td>
                                                ৳
                                                {{
                                                  floatingPointPlaces(
                                                    routeWiseDailyEarningCalculation +
                                                      routeWiseShuttleBonusCalculation,
                                                    2
                                                  )
                                                }}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                              </div>
                            </template>
                          </template>
                        </template>
                      </template>
                      <div
                        class="tab-pane fade"
                        id="adjustedAmountsTab"
                        role="tabpanel"
                        aria-labelledby="adjustedAmountsTab"
                      >
                        <div class="row">
                          <div class="table-responsive">
                            <table class="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <!-- <th>Time</th> -->
                                  <th>Debit</th>
                                  <th>Credit</th>
                                </tr>
                              </thead>
                              <tbody>
                                <template
                                  v-for="(data, index) in adjustedAmount"
                                  :key="index"
                                >
                                  <tr>
                                    <td>
                                      {{
                                        formatDateUsingMoment(
                                          data.bills_adjustment_datetime
                                        )
                                      }}
                                    </td>
                                    <!-- <td>
                                      {{
                                        formatTimeUsingMoment(
                                          data.bills_adjustment_datetime
                                        )
                                      }}
                                    </td> -->
                                    <td>
                                      ৳
                                      {{
                                        floatingPointPlaces(
                                          data.adjusment_debited,
                                          2
                                        )
                                      }}
                                    </td>
                                    <td>
                                      ৳
                                      {{
                                        floatingPointPlaces(
                                          data.adjusment_credited,
                                          2
                                        )
                                      }}
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- Payment Methods Modal -->
        <Transition name="fade">
          <PaymentMethods
            v-if="showPaymentMethodsModal"
            :userCode="selectedOwnerCode"
            :date="date"
            :modality="filterValue.modality"
            :serviceType="filterValue.service_type"
            @closeModal="showPaymentMethodsModal = !showPaymentMethodsModal"
            @refreshData="refreshPaymentMethod"
          ></PaymentMethods>
        </Transition>
      </div>
    </teleport>
    <!-- Bill adjustment Modal -->
    <teleport to="body">
      <div
        class="modal fade"
        id="billAdjustment"
        tabindex="-1"
        aria-labelledby="billAdjustmentLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <BillAdjustment
            :billId="selectedBillId"
            :driverCode="selectedDriverCode"
            :ownerCode="selectedOwnerCode"
            @syncBillData="getBillList"
          ></BillAdjustment>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import '@vuepic/vue-datepicker/dist/main.css';
import moment from 'moment';
import http from '../../config/axios';
import userService from '../../config/axiosUserService';
import AttendancePagesHeading from '../attendancePages/AttendancePagesHeading.vue';
import CustomDataTable from '../customDataTable/CustomDataTable.vue';
import BillAdjustment from './BillAdjustment.vue';
import BillSummaryFleetVariable from './BillSummaryFleetVariable.vue';
import BillRouteDataFleetVariable from './BillRouteDataFleetVariable.vue';
import userServiceAPI from '../../store/userServiceAPI';
import PaymentMethods from './PaymentMethods.vue';

export default {
  name: 'BillView',
  props: ['alert', 'swal'],
  components: {
    CustomDataTable,
    AttendancePagesHeading,
    BillAdjustment,
    PaymentMethods,
    BillSummaryFleetVariable,
    BillRouteDataFleetVariable
  },
  data() {
    return {
      permissions: localStorage.getItem('userPermission').split(','),
      filterOption: ['Name', 'Phone', 'bKash No', 'Bill Status'],
      filterValue: {
        name: '',
        phone: '',
        account_no: '',
        bill_status: '',
        modality: localStorage.getItem('modality'),
        service_type: localStorage.getItem('serviceType'),
        type: ''
      },
      selectFilter: '',
      searchValue: '',
      statusOption: ['Pending', 'Approved', 'Requested'],
      // status: '',
      billList: [],
      paginatedFilteredBillList: [],
      totalPages: 0,
      total: 0,
      currentPage: 1,
      perPage: 0,
      pageCount: '',
      to: 0,
      from: 0,
      driverDetails: [],
      paginationValue: '20',
      isLoading: true,
      // billDateUserDetails: {},
      billUserName: '',
      billUserPayNum: '',
      isBillSummaryLoading: true,
      isDateRouteBillSummaryLoading: '',
      routeDateWiseAmountSummary: [],
      routeWiseDailyTransaction: [],
      adjustedAmount: [],
      routeDateWiseBonusAmount: [],
      // serviceWiseCompletionBonus: {},
      // totalWeeklyIncome: {},
      editBkashNumber: '',
      editBkashUserCode: '',
      billingUserCode: '',
      searchUserCode: [],
      tripBillStatus: 'Pending',
      driverDetailsObj: {},
      tzoffset: new Date().getTimezoneOffset() * 60000,
      selectedBill: {},
      selectedBillId: null,
      selectedOwnerCode: null,
      selectedDriverCode: null,
      billDriverDetails: [],
      billDriverDetailsObj: {},
      userRouteWiseTripIncome: {},
      currentHolidays: null,
      date: null,
      showPaymentMethodsModal: false
    };
  },
  watch: {
    date: {
      handler: function () {
        this.billList = [];
        this.getBillList();
      },
      deep: true
    },
    // selectFilter: {
    //   handler: function () {
    //     this.pickDisplay();
    //     this.searchValue = '';
    //     this.status = '';
    //   }
    // },
    searchValue: {
      handler: function () {
        // if (this.selectFilter === 'Name') {
        //   let url = `v1/users/search?field=name&return=mobile,name,user_code&key=${this.searchValue}&limit=50`;
        //   this.searchData(url);
        // }
        // if (this.selectFilter === 'Phone') {
        //   this.searchValue = '';
        //   let url = `v1/users/search?field=mobile&return=mobile,name,user_code&key=${this.searchValue}&limit=50`;
        //   this.searchData(url);
        // }
        // if (this.selectFilter === 'bKash No') {
        //   this.getBillList();
        // }
        // if (this.selectFilter === 'Bill Status') {
        //   this.getBillList();
        // }
      },
      paginationValue: {
        handler: function () {
          this.getBillList();
        }
      }
    },
    filterValue: {
      handler: function (newValue, oldValue) {
        // Date change is in effect on change modality
        if (oldValue.modality === newValue.modality) {
          this.billList = [];
          this.getBillList();
        }
      },
      deep: true
    }
  },
  mounted() {
    // this.getBillList();
    this.getCurrentHolidays();
  },
  computed: {
    routeWiseShuttleBonusCalculation() {
      var sum = 0;
      for (const key in this.refinedRouteDateWiseAmount) {
        sum += this.refinedRouteDateWiseAmount[key].shuttleBonus;
      }
      return sum;
    },
    routeWiseDailyEarningCalculation() {
      let sum = 0;
      for (const key in this.refinedRouteDateWiseAmount) {
        sum += this.refinedRouteDateWiseAmount[key].tripAmount;
      }
      return sum;
    },
    refinedRouteDateWiseAmount() {
      let refinedData = {};

      this.routeDateWiseAmountSummary.forEach((amountSummary) => {
        if (!refinedData[amountSummary.attendance_id]) {
          refinedData[amountSummary.attendance_id] = {
            attendance_id: amountSummary.attendance_id,
            route_id: amountSummary.route_id,
            status: amountSummary.status,
            time: amountSummary.time,
            trip_start_date_time: amountSummary.trip_start_date_time,
            user_code: amountSummary.user_code,
            tripAmount: 0,
            shuttleBonus: 0
          };
        }
        if (
          amountSummary.transaction_types_id == 1 &&
          amountSummary.status == 'Present'
        ) {
          refinedData[amountSummary.attendance_id].tripAmount =
            amountSummary.credit;
        } else if (
          amountSummary.transaction_types_id == 2 &&
          amountSummary.status == 'Present'
        ) {
          refinedData[amountSummary.attendance_id].shuttleBonus =
            amountSummary.credit;
        }
      });

      return refinedData;
    },
    uniqueTripCodeRoutes() {
      let uniqueTRCodes = [];
      let uniqueTripCodeRoutes = [];

      for (const key in this.userRouteWiseTripIncome) {
        if (
          this.userRouteWiseTripIncome[key]
            .routeWiseTripIncomeAndShuttleBonus ||
          this.userRouteWiseTripIncome[key].routeWiseTripIncome
        ) {
          let data = this.userRouteWiseTripIncome[key]
            .routeWiseTripIncomeAndShuttleBonus
            ? this.userRouteWiseTripIncome[key]
                .routeWiseTripIncomeAndShuttleBonus
            : this.userRouteWiseTripIncome[key].routeWiseTripIncome;

          data.forEach((element) => {
            if (!uniqueTRCodes.includes(element.trip_code)) {
              uniqueTRCodes.push(element.trip_code);
              uniqueTripCodeRoutes.push(element);
            }
          });
        }
      }

      return uniqueTripCodeRoutes;
    },
    filteredBillList() {
      let filteredBills = this.billList;

      if (
        this.filterValue.name ||
        this.filterValue.phone ||
        this.filterValue.account_no
      ) {
        filteredBills = this.billList.filter((bill) => {
          if (this.driverDetailsObj[bill.user_code]) {
            let nameCondititon = this.filterValue.name
              ? this.driverDetailsObj[bill.user_code].name
                  .toLowerCase()
                  .indexOf(this.filterValue.name.toLowerCase()) > -1
              : true;
            let mobileCondititon = this.filterValue.phone
              ? this.driverDetailsObj[bill.user_code].mobile.indexOf(
                  this.filterValue.phone
                ) > -1
              : true;
            let bkashCondititon = this.filterValue.account_no
              ? bill.account_no
                ? bill.account_no.indexOf(this.filterValue.account_no) > -1
                : false
              : true;

            if (nameCondititon && mobileCondititon && bkashCondititon) {
              return true;
            }
            return false;
          }
          return false;
        });
      }

      return filteredBills;
    },
    grandTotalWeeklyIncome() {
      let grandTotalWeeklyIncome = 0;

      for (const key in this.userRouteWiseTripIncome) {
        grandTotalWeeklyIncome += parseFloat(
          this.userRouteWiseTripIncome[key].totalIncome
        );
      }

      return grandTotalWeeklyIncome;
    }
  },
  methods: {
    fetchPaginatedData(paginatedData) {
      this.paginatedFilteredBillList = paginatedData;
    },
    floatingPointPlaces(value, places) {
      let refinedValue = value.toString();
      if (typeof value === 'number') {
        let splittedValue = value.toString().split('.');
        if (splittedValue.length == 2 && splittedValue[1].length > places) {
          splittedValue[1] = splittedValue[1].slice(0, places);
          refinedValue = splittedValue.join('.');
        }
      }
      return refinedValue;
    },
    totalCompletionBonus(data) {
      let totalBonus = 0;

      data.forEach((ele) => {
        totalBonus += ele.completion_amount;
      });

      return totalBonus;
    },
    filterSearch(searchValues) {
      this.filterValue = {
        name: '',
        phone: '',
        account_no: '',
        bill_status: '',
        modality: localStorage.getItem('modality'),
        service_type: localStorage.getItem('serviceType'),
        type: ''
      };
      for (const key in searchValues) {
        this.filterValue[key] = searchValues[key];
      }
      // if (this.status != searchValues.bill_status) {
      //   this.status = searchValues.bill_status;
      // }
    },
    changeDate(selectedDate) {
      this.date = selectedDate;
    },
    selectSummaryTab() {
      if (this.$refs.summaryTab) {
        this.$refs.summaryTab.click();
      }
      this.selectedDriverCode = 'summary';
    },
    selectUserRouteTab(key) {
      this.selectedDriverCode = key;
      setTimeout(() => {
        if (this.$refs.userRouteTab && Array.isArray(this.$refs.userRouteTab)) {
          this.$refs.userRouteTab[0].click();
        } else if (this.$refs.userRouteTab) {
          this.$refs.userRouteTab.click();
        }
      }, 10);
    },
    switchTab(key, id) {
      this.selectedDriverCode = key;
      setTimeout(() => {
        document.getElementById(id).click();
      }, 10);
    },
    reverseBill(billId) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You want to reverse the transaction?',
        icon: 'warning',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes!'
      }).then((result) => {
        if (result.value) {
          http
            .post(`v2/partners/bills/reverse/${billId}`)
            .then((response) => {
              if (response.status === 200) {
                this.$swal('Success', response.data.message, 'success');
                this.getBillList();
              }
            })
            .catch((error) => {
              console.log(error);
              this.errored = true;
            });
        }
      });
    },
    searchData(url) {
      this.searchUserCode = [];
      userService
        .get(url)
        .then((response) => {
          let user_info = response.data.data;
          user_info.forEach((users) => {
            this.searchUserCode.push(users.user_code);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // pickDisplay() {
    //   let inputFilter = document.getElementById('inputFilter');
    //   let billFilter = document.getElementById('billFilter');

    //   if (
    //     this.selectFilter &&
    //     (this.selectFilter.indexOf('Name') ||
    //       this.selectFilter.indexOf('Phone') ||
    //       this.selectFilter.indexOf('bKash No') > -1)
    //   ) {
    //     inputFilter.style.display = 'block';
    //   } else {
    //     inputFilter.style.display = 'none';
    //   }

    //   if (this.selectFilter && this.selectFilter.indexOf('Bill Status') > -1) {
    //     billFilter.style.display = 'block';
    //     inputFilter.style.display = 'none';
    //   } else {
    //     billFilter.style.display = 'none';
    //   }
    // },
    updateBillSummaryAccordingUser() {
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);

      const data = {
        start_date: startDate,
        end_date: endDate,
        user_code: this.billingUserCode,
        status: 'approved',
        modality: this.filterValue.modality,
        service_type: this.filterValue.service_type,
        type: this.filterValue.type
      };

      http
        .post(`v2/partners/transaction/history`, data)
        .then((response) => {
          if (response.status === 200) {
            this.getBillList();
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
    updateBkashNumber() {
      const data = {
        user_code: this.editBkashUserCode,
        bkash_number: this.editBkashNumber
      };

      http
        .patch(`v1/users/profile`, data)
        .then((response) => {
          if (response.status === 200) {
            this.billList = [];
            this.getBillList();
            // window.location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
    getListWiseBkashNumber(bill_user_code) {
      this.editBkashNumber = this.billList.find(
        (data) => data.user_code === bill_user_code
      ).bkash_number;
      this.editBkashUserCode = bill_user_code;
    },
    // getBonusAmount(data) {
    //   this.routeDateWiseBonusAmount = [];
    //   data.forEach((data) => {
    //     if (data.bonus_name === 'Shuttle Bonus') {
    //       this.routeDateWiseBonusAmount.push({
    //         attendances_id: data.attendances_id,
    //         amount: data.amount
    //       });
    //     }
    //   });
    // },
    getDateRouteWiseAmountCalculationShow(
      route_id,
      user_code,
      service_type,
      bill_id
    ) {
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      this.isDateRouteBillSummaryLoading = true;
      this.routeDateWiseAmountSummary = [];
      this.selectedBillId = bill_id;

      http
        .get(
          `/v2/partners/bills/trip?start_date=${startDate}&end_date=${endDate}&route_id=${route_id}&user_code=${user_code}&modality=${this.filterValue.modality}&type=${this.filterValue.type}&serviceType=${service_type}&owner_code=${this.selectedOwnerCode}&driver_code=${user_code}&bills_id=${bill_id}`
        )
        .then((response) => {
          if (response.status === 200) {
            this.routeDateWiseAmountSummary =
              response.data.data.transaction_for_trips;
            this.routeWiseDailyTransaction =
              response.data.data.transaction_daily;
            this.adjustedAmount = response.data.data.adjusted_bills;
            // this.routeDateWiseAmountSummary.forEach((data) => {
            //   this.getBonusAmount(data.bonus);
            // });
            setTimeout(() => {
              this.isDateRouteBillSummaryLoading = false;
            }, 1000);
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
    getBillSummaryUserName(userCode) {
      this.billUserName = this.driverDetails.find(
        (data) => data.user_code === userCode
      ).name;
      this.billUserPayNum = this.billList.find(
        (data) => data.user_code === userCode
      ).bkash_number;
      this.billingUserCode = userCode;
    },
    // processBillData(data) {
    //   for (const key in data) {
    //     this.billDateUserDetails[key] = data[key].route_wise_weekly_income;
    //     this.serviceWiseCompletionBonus[key] =
    //       data[key].service_wise_completion_bonus;
    //     this.totalWeeklyIncome[key] = data[key].weekly_income;
    //   }
    // },
    getBillListAccordingDateUserCode(bill) {
      let userCode = bill.user_code;
      // Bill Status Generating
      // if (
      //   bill.total === bill.disbursed &&
      //   bill.total === bill.requested &&
      //   bill.total === bill.approved
      // ) {
      //   this.tripBillStatus = 'Pending';
      // } else if (0 < bill.disbursed) {
      //   this.tripBillStatus = 'Disbursed';
      // } else if (0 < bill.requested) {
      //   this.tripBillStatus = 'Requested';
      // } else if (0 < bill.approved) {
      //   this.tripBillStatus = 'Approved';
      // }
      if (bill.pending > bill.approved && bill.approved === 0) {
        this.tripBillStatus = 'Pending';
      } else if (
        bill.pending === bill.approved &&
        bill.approved === bill.requested
      ) {
        this.tripBillStatus = 'Requested';
      } else if (bill.pending > bill.approved) {
        this.tripBillStatus = 'Partially Approved';
      } else if (bill.pending === bill.approved) {
        this.tripBillStatus = 'Approved';
      }

      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);

      this.getBillSummaryUserName(userCode);
      this.selectedOwnerCode = userCode;
      this.selectedBill = bill;
      this.selectedBillId = bill.bills_id;

      this.isBillSummaryLoading = false;
      http
        .get(
          `/v2/partners/bills/user/route?start_date=${startDate}&end_date=${endDate}&user_code=${userCode}&modality=${this.filterValue.modality}&service_type=${this.filterValue.service_type}&type=${this.filterValue.type}`
        )
        .then((response) => {
          this.isBillSummaryLoading = false;
          if (response.status === 200) {
            this.userRouteWiseTripIncome = response.data.data;
            // this.processBillData(response.data.data);

            userServiceAPI
              .getUserDetails(Object.keys(response.data.data))
              .then((res) => {
                this.isBillSummaryLoading = false;
                this.billDriverDetails = res.data.data;
                this.billDriverDetailsObj = userServiceAPI.mapUsersIntoObject(
                  res.data.data
                );
              })
              .catch(() => {
                this.isBillSummaryLoading = false;
              });
          }
        })
        .catch((error) => {
          this.isBillSummaryLoading = false;
          console.log(error);
          this.errored = true;
        });
    },
    pageReload() {
      location.reload();
    },
    // mapDriverDetailsIntoObject() {
    //   this.driverDetails.forEach((driver) => {
    //     this.driverDetailsObj[driver.user_code] = driver;
    //   });
    // },
    // mapBillDriverDetailsIntoObject() {
    //   this.billDriverDetails.forEach((driver) => {
    //     this.billDriverDetailsObj[driver.user_code] = driver;
    //   });
    // },
    refreshPaymentMethod() {
      this.getBillList(() => {
        if (this.selectedBillId) {
          this.selectedBill = this.billList.find(
            (bill) => bill.bills_id === this.selectedBillId
          );
        }
      });
    },
    getBillList(callback = () => null) {
      this.isLoading = true;
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);

      http
        .get(
          `/v2/partners/bills/user?start_date=${startDate}&end_date=${endDate}&status=${
            this.filterValue.bill_status
              ? this.filterValue.bill_status.toLowerCase()
              : ''
          }&modality=${
            this.filterValue.modality ? this.filterValue.modality : ''
          }&service_type=${
            this.filterValue.service_type ? this.filterValue.service_type : ''
          }&type=${this.filterValue.type}`
        )
        .then((response) => {
          if (response.status === 200) {
            this.billList = response.data.data;
            // this.total = response.data.data.total;
            // this.totalPages = response.data.data.last_page;
            // this.currentPage = response.data.data.current_page;
            // this.perPage = response.data.data.per_page;
            // this.to = response.data.data.to;
            // this.from = response.data.data.from;
            let userCodes = this.billList.map((bill) => bill.user_code);
            let driverCodes = this.billList.map((bill) => bill.drivers);
            callback();

            userServiceAPI
              .getUserDetails([...userCodes, ...driverCodes])
              .then((res) => {
                this.isLoading = false;
                this.driverDetails = res.data.data;
                this.driverDetailsObj = userServiceAPI.mapUsersIntoObject(
                  res.data.data
                );
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
          this.isLoading = false;
        });
    },
    // getDriverDetails(id, callback) {
    //   userService
    //     .get(
    //       `v1/users?user_code=${id.join(
    //         ','
    //       )}&fields=name,mobile,user_code,email,status&limit=500`
    //     )
    //     .then((response) => {
    //       this.isLoading = false;
    //       callback(response);
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    billDriverNames(bill) {
      let driverNames = '';
      let driverCodes = bill.drivers ? bill.drivers.split(',') : [];

      driverCodes.forEach((driverCode, index) => {
        let driver = this.driverDetails.find(
          (driver) => driver.user_code === driverCode
        );
        if (driver) {
          if (index !== 0) {
            driverNames += ', ';
          }
          driverNames += driver.name;
        }
      });

      return driverNames ? driverNames : 'N/A';
    },
    formatDateUsingMoment(date) {
      return moment(date).format('DD.MM.YYYY');
    },
    formatTimeUsingMoment(dateTime) {
      return moment(dateTime).format('hh:mm:ss a');
    },
    getCurrentHolidays() {
      http
        .get('v2/settings/holidays')
        .then((response) => {
          if (response.status == 200) {
            this.currentHolidays = response.data?.data?.count;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert(error.response.data.msg);
          console.log(error);
        });
    }
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.bill-payment {
  font-family: Montserrat;
  /*background-color: #F3F3F3;*/
}

.bill-payment h1 {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #000000;
}

.attendance-tab {
  font-weight: 600;
}

#billSummaryModal .modal-body {
  padding: 22px;
}

#billSummaryModal .modal-header {
  padding: 15px 22px;
}
#billSummaryModal .modal-body {
  padding: 22px;
}

#billSummaryModal table {
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.07);
  border-radius: 4px 4px 0px 0px;
}
#billSummaryModal table thead tr th {
  font-size: 13px;
  font-weight: 500;
  padding: 11px 15px;
}
#billSummaryModal table tbody tr td {
  font-size: 13px;
  font-weight: 400;
  padding: 10px 12px;
}
#billSummaryModal .card {
  padding: 1rem 1rem;
  border-radius: 7px;
}
#billSummaryModal .card-body {
  padding: 0;
}
#billSummaryModal .nav-link {
  font-size: 13px;
  font-weight: 500;
  color: #000;
}

#billSummaryModal .nav-pills .nav-link {
  font-size: 13px;
  font-weight: 500;
  color: #000;
  background: #f3f3f3;
}

#billSummaryModal .nav-pills .active {
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  background: #652f8f !important;
}

.bill-nav .active {
  color: #652f8f !important;
}

nav-link {
  position: absolute;
  width: 84px;
  height: 14px;
  left: 76px;
  top: 177px;

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #000000;
}

table thead {
  background-color: #f3f3f3;
}

table {
  font-size: 15px;
  align-content: center;
}

table tbody {
  border-top: none !important;
}

table th,
table td {
  vertical-align: middle;
  padding: 0.5rem;
}
</style>
